import {createElement} from "react";
import {isNotStringOrEmptyString} from "@utils/string";
import {isPlainObject} from "@utils/object";
import {addUniqueCssClasses} from "@functions/css";

const HEADING_LEVELS = {
   2: "h2",
   3: "h3",
   4: "h4",
   5: "h5",
   6: "h6",
};

/**
 * @param {{
 *   text?: string,
 *   children?: import('react').ReactNode,
 *   headingCssClass?: string,
 *   headingProps?: Record<string, unknown>,
 *   headingLevel?: 2 | 3 | 4 | 5 | 6,
 * }} props
 */
export default function SectionHeading(
    {
        text = 'Heading Text',
        children,
        headingCssClass = 'mb-4 bottom-border',
        headingProps = {},
        headingLevel = 3,
    }
) {

    if(isNotStringOrEmptyString(headingCssClass)) {
        headingCssClass = 'mb-4 bottom-border';
    } else {
       headingCssClass = addUniqueCssClasses('bottom-border', headingCssClass);
    }

    if(!isPlainObject(headingProps)) {
        headingProps = {};
    }

    const level =
       typeof headingLevel === "number" && headingLevel >= 2 && headingLevel <= 6
          ? headingLevel
          : 3;
    const tagName = HEADING_LEVELS[level] || "h3";

    if (children) {
        return createElement(tagName, {className: headingCssClass, ...headingProps}, children);
    }
    if (text) {
        return createElement(tagName, {className: headingCssClass, ...headingProps}, text);
    }
    return null;
}